module.exports = __webpack_public_path__ + "f3dfc3d98d7b183cdc66cb46143969ae.pdf";